import React, { useState, useEffect } from "react";
import logo from "../image/logo_grow.png";
import { motion, AnimatePresence } from "framer-motion";


function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["services", "about", "projects", "testimonial", "contact"];

      let current = "";

      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const sectionTop = section.offsetTop - 120;
          const sectionHeight = section.offsetHeight;

          if (
            window.scrollY >= sectionTop &&
            window.scrollY < sectionTop + sectionHeight
          ) {
            current = id;
          }
        }
      });

      setActive(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = ["Services", "About", "Projects", "Testimonial", "Contact"];

  return (
    <>
     <nav className="sticky top-0 z-50 bg-white/70 backdrop-blur-xl border-b border-white/20 shadow-sm">
     <div className="max-w-6xl mx-auto flex justify-between items-center px-6  py-3">
        <h1 className="text-xl font-semibold text-indigo-600">
          <a href="">
            <img src={logo}  alt="logoimg" className="w-[150px] max-[300px]:w-[100px]"/>
          </a>
        </h1>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8">
          {navItems.map((item, i) => {
            const id = item.toLowerCase();
            const isActive = active === id;

            return (
              <a
                key={i}
                href={`#${id}`}
                className={`relative group font-semibold transition-all duration-300 ${
                  isActive
                    ? "bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent"
                    : "text-gray-700 hover:bg-gradient-to-r hover:from-indigo-600 hover:via-purple-600 hover:to-pink-500 hover:bg-clip-text hover:text-transparent"
                }`}
              >
                {item}

                {/* Underline */}
                <span
                 className={`absolute left-0 -bottom-1 h-[2px] bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 transition-all duration-300 ${
                  isActive ? "w-full" : "w-0 group-hover:w-full"
                }`}
                ></span>
              </a>
            );
          })}
        </div>

        {/* Mobile Button */}
        <button
          className="md:hidden text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
        </div>
        </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
        className={`fixed inset-0 z-50 md:hidden ${
          menuOpen ? "pointer-events-auto" : "pointer-events-none"
        }`}
      >
        {/* Overlay */}
        <div
          onClick={() => setMenuOpen(false)}
          className={`fixed inset-0 z-40 bg-black/40 backdrop-blur-sm transition-opacity duration-500 ${
            menuOpen
              ? "opacity-100 visible"
              : "opacity-0 invisible"
          }`}
        />
      
        {/* Sidebar */}
        <AnimatePresence>
  {menuOpen && (
    <motion.div
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      exit={{ x: "-100%" }}
      transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1],
      }}
      className="fixed top-0 left-0 z-50 h-screen w-[82%] max-w-sm bg-white/95 backdrop-blur-xl border-r border-white/20 shadow-2xl rounded-r-3xl"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
        <a href="#">
          <img src={logo} alt="logo" className="w-[100px]" />
        </a>

        <button
          onClick={() => setMenuOpen(false)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-700 transition-all duration-300 hover:bg-pink-500 hover:text-white hover:rotate-90"
        >
          ✕
        </button>
      </div>

      {/* Navigation */}
      <div className="flex flex-col px-5 py-6 gap-2">
        {navItems.map((item, i) => {
          const id = item.toLowerCase();
          const isActive = active === id;

          return (
            <a
              key={i}
              href={`#${id}`}
              onClick={() => setMenuOpen(false)}
              className={`group flex items-center justify-between rounded-2xl px-4 py-3 text-[15px] font-semibold transition-all duration-300 ${
                isActive
                  ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
                  : "text-gray-700 hover:bg-purple-50 hover:text-purple-600"
              }`}
            >
              <span>{item}</span>

              <span
                className={`transition-all duration-300 ${
                  isActive
                    ? "translate-x-0 opacity-100"
                    : "translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
                }`}
              >
                →
              </span>
            </a>
          );
        })}
      </div>
    </motion.div>
  )}
</AnimatePresence>
      </div>
      )}
       
    </>
  );
}

export default Navbar;